import type React from 'react';

import { Avatar, Text } from '@change/ds-core-ui';
import { CheckCircleOutlineIcon } from '@change/ds-icons';

import { useI18n } from '@change-corgi/core-react/i18n';

import type { MilestoneCardData } from '../../hooks/usePetitionMarquee';
import { CardWrapper } from '../CardWrapper';

type Props = Readonly<{
	petition: MilestoneCardData;
	onClick: () => void;
	duplicate?: boolean;
}>;

export const MilestoneCard: React.FC<Props> = ({ petition, onClick, duplicate = false }) => {
	const { translate } = useI18n();

	return (
		<CardWrapper
			cardKey={petition.key}
			href={petition.href}
			onClick={onClick}
			duplicate={duplicate}
			icon={CheckCircleOutlineIcon}
			label={translate('corgi.homepage.petition_marquee.milestone_label')}
			trailingLabel={petition.relativeTimeLabel}
		>
			<div className="flex grow flex-row items-center gap-3">
				<Avatar src={petition.imageUrl} alt="" aria-hidden size={72} className="shrink-0 object-cover" />
				<div className="flex min-w-0 flex-col">
					<Text as="span" variant="body" size="x-large" fontWeight="bold" className="text-typography-strong">
						{petition.milestoneSignaturesLabel}
					</Text>
					<Text as="span" variant="body" size="x-small" className="text-typography-weak line-clamp-1">
						{translate('corgi.homepage.petition_marquee.on_petition', { title: petition.title })}
					</Text>
				</div>
			</div>
		</CardWrapper>
	);
};
